import { cva } from 'class-variance-authority';

export type Variant = 'inverse' | 'shade' | 'accent';

export const inputVariants = cva('tw:pl-6 tw:block tw:!h-10 tw:transition-all tw:duration-300', {
  variants: {
    variant: {
      shade: 'tw:bg-primary-100 tw:border-primary-500 tw:text-secondary-400',
      inverse: 'tw:!border-primary-600 tw:!bg-transparent tw:!text-secondary-600',
      accent: 'tw:bg-accent-100  tw:border-accent-500  tw:text-accent-700',
    },
  },
  defaultVariants: { variant: 'shade' },
});

export const iconVariants = cva('tw:!text-base', {
  variants: {
    variant: {
      shade: 'tw:text-secondary-400',
      inverse: 'tw:text-secondary-500/95',
      accent: 'tw:text-accent-700',
    },
    size: {
      md: 'tw:!text-base',
      sm: 'tw:!text-xs',
    },
  },
  defaultVariants: {
    variant: 'shade',
    size: 'md',
  },
});

export const dividerVariants = cva('tw:h-6 tw:w-[1px] tw:absolute tw:top-2 tw:right-[40px]', {
  variants: {
    variant: {
      shade: 'tw:bg-secondary-400/25',
      inverse: 'tw:bg-secondary-400',
      accent: 'tw:bg-accent-500/25',
    },
  },
  defaultVariants: { variant: 'accent' },
});
